// Generated by scripts/write-build-info.js. Do not edit manually.
export const BUILD_INFO = {
  "version": "2.11.2",
  "buildId": "2.11.2-HEAD-cc3268a69d74-2026-10-30T08-48-29.565Z",
  "commit": "cc3268a69d7462af9aca33b2af228313617cc370",
  "branch": "HEAD",
  "buildNumber": "",
  "builtAt": "2026-10-30T08:48:29.565Z"
} as const;
